import type { APIClient } from '@src/shared/api';
import { prefetchQuery } from '@src/shared/query';
import { resourceUsersUrl } from './constants';

export default function prefetchResourceUsers(client: APIClient) {
  return prefetchQuery(resourceUsersUrl, client, {});
}
